import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';

import { StoreProvider } from './store/useStore';
import * as serviceWorker from './serviceWorker';
import AppContainer from './App/AppContainer';

ReactDOM.render(
	<StoreProvider>
		<AppContainer />
	</StoreProvider>,
	document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
